import { TrimbimModel } from '@technology/web3d-plugin-trimbim';
import { ConnectIdentifierBuilder } from '@technology/web3d-plugin-trimbim/dist/esnext/Extras/ConnectIdentifier/ConnectIdentifier';
import { ConnectIdentifierResolver } from '@technology/web3d-plugin-trimbim/dist/esnext/Extras/ConnectIdentifier/ConnectIdentifierResolver';
import { getLogger } from '@trimble/logging';

const IDENTIFIER_TOLERANCE = 1e-3;
const DEFAULT_MODEL_SCALING = 1.0;

export const identifierBuilder = new ConnectIdentifierBuilder();

export async function buildResolver(
  model: TrimbimModel
): Promise<ConnectIdentifierResolver> {
  const entities = await model.getEntities();
  const boundingBoxes = await model.getBoundingBoxesForConnectIdentifier();
  const resolver = new ConnectIdentifierResolver();
  resolver.addEntities(
    entities,
    boundingBoxes,
    IDENTIFIER_TOLERANCE,
    DEFAULT_MODEL_SCALING
  );
  return resolver;
}

export function resolveSourceIdToEntityIds(
  resolver: ConnectIdentifierResolver,
  sourceId: string
): number[] {
  const persistentId = resolver.tryGetEntityFromPersistentIdentifier(sourceId);
  if (persistentId !== undefined && persistentId !== -1) {
    return [persistentId];
  }

  const nonPersistentIds =
    resolver.tryGetEntityFromNonPersistentIdentifier(sourceId);
  return nonPersistentIds.filter((id) => id !== undefined && id !== -1);
}

export async function extractEntitySourceIds(
  model: TrimbimModel,
  entityIds: number[]
): Promise<(string | undefined)[]> {
  const entities = await model.getEntities(entityIds);
  const boundingBoxes =
    await model.getBoundingBoxesForConnectIdentifier(entityIds);

  const result: (string | undefined)[] = [];

  for (let i = 0; i < entities.length; i++) {
    const entity = entities[i];
    try {
      let sourceId = identifierBuilder.tryGetPersistentIdentifier(entity);
      if (sourceId === undefined) {
        sourceId = identifierBuilder.tryGetNonPersistentIdentifier(
          entity,
          boundingBoxes[i]
        );
      }
      result.push(sourceId);
    } catch (error) {
      getLogger().warn(`Failed to get identifier for entity ${entity.id}`, {
        error,
      });
      result.push(undefined);
    }
  }

  return result;
}
